import { useState, useRef, useCallback } from 'react';

// Browser speech-to-text (Chrome/Edge). Returns { supported, listening, toggle }.
// onText gets the final transcript, so callers can drop it straight into an input.
export default function useVoiceInput(onText, lang = 'hi-IN') {
  const Recognition = window.SpeechRecognition || window.webkitSpeechRecognition;
  const [listening, setListening] = useState(false);
  const recRef = useRef(null);

  const toggle = useCallback(() => {
    if (!Recognition) return;
    if (recRef.current) {
      recRef.current.stop();
      recRef.current = null;
      setListening(false);
      return;
    }
    const rec = new Recognition();
    rec.lang = lang;
    rec.interimResults = false;
    rec.maxAlternatives = 1;
    rec.onresult = (e) => {
      const text = Array.from(e.results).map(r => r[0].transcript).join(' ').trim();
      if (text) onText(text);
    };
    rec.onend = () => { recRef.current = null; setListening(false); };
    rec.onerror = () => { recRef.current = null; setListening(false); };
    recRef.current = rec;
    setListening(true);
    rec.start();
  }, [Recognition, lang, onText]);

  return { supported: !!Recognition, listening, toggle };
}
